import { useCallback, useState } from "react";

import { Button } from "~/components/ui/button";

import {
  exportDashboardPdf,
  getPdfExportTitle,
  getProductionDashboardUrl,
} from "./dashboardsPdfExport";

/** `title` names the PDF; it defaults to the catalog entry for the current route. */
export function DashboardsPdfExportButton(props: {
  title?: string;
  /** Outline when another control on the page is the primary action. */
  variant?: "default" | "outline";
}) {
  const [preparing, setPreparing] = useState(false);
  const dashboardUrl = getProductionDashboardUrl();

  const exportPdf = useCallback(async () => {
    if (preparing) return;
    setPreparing(true);
    await exportDashboardPdf({
      onSettled: () => {
        setPreparing(false);
      },
      title: props.title ?? getPdfExportTitle(window.location.pathname),
    });
  }, [preparing, props.title]);

  return (
    <>
      <Button
        type="button"
        size="sm"
        variant={props.variant ?? "default"}
        data-dashboard-pdf-export=""
        disabled={preparing}
        aria-label="Export this dashboard as a single-page PDF"
        onClick={() => {
          void exportPdf();
        }}
      >
        {preparing ? "Preparing PDF…" : "Export PDF"}
      </Button>
      <a
        className="hidden text-sm font-semibold text-primary underline"
        data-dashboard-pdf-link=""
        href={dashboardUrl}
        target="_blank"
        rel="noreferrer"
      >
        Open dashboard ↗
      </a>
    </>
  );
}
